import { CommonModule } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    SkipSelf,
} from '@angular/core';
import {
    ControlContainer,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipComponent } from 'app/components/tooltip/tooltip.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'select-general',
    templateUrl: './select-general-application.component.html',
    styleUrls: ['./select-general-application.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        TooltipComponent,
        MatTooltipModule
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
})
export class SelectGeneralApplicationComponent{
    @Input() options: { value: any; label: string }[] = [];
    @Input() label: string = '';
    @Input() placeHolder: string = '';
    @Input() currentValue: string = '';
    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() dropdownToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() mandatoryField: boolean = false;
    @Input() controlName?: string;
    @Input() errors: string[] = [];
    @Input() classOverrides: string | null = null;
    @Input() backgroundOverride: string | undefined;
    @Input() isDropdownOpen: boolean;
    @Input() headerUnderline: boolean = false;
    @Input() contentUnderline: boolean = false;
    @Input() tooltipDataHeading: any;
    @Input() tooltipDataOption:any = {
        header: 'Working Capital',
        content: 'Financing facility for your daily business operations.'
    };
    @Input() TooltipData= {
        header: '',
        content: ''
    };
    isTooltipOpen: boolean = false
    isTooltipOpenHeader: boolean = false
    constructor(private el: ElementRef) {}

    getCurrentLabel() {
        return this.options.find((option) => option.value === this.currentValue)
            ?.label;
    }

    toggleTooltipHeader(){
        this.isTooltipOpen = false;
        this.isTooltipOpenHeader = !this.isTooltipOpenHeader
    }

    toggleDropdown(e) {
        if(this.options.length > 1) {
            this.isTooltipOpenHeader = false
            this.isTooltipOpen = false;
            if (this.isDropdownOpen === e) {
                this.closeDropdown();
                return;
            }
            this.isDropdownOpen = e;
            this.dropdownToggle.emit(e);
        }
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    selectOption($event, option: any) {
        $event.stopPropagation();
        this.selectionChange.emit(option);
        this.closeDropdown();
    }

    toggleTooltip(e: any){
        this.isTooltipOpenHeader = false
        this.isTooltipOpen = !this.isTooltipOpen
        e.stopPropagation();
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        if (!this.el.nativeElement.contains(event.target)) {
            this.isTooltipOpen = false;
            this.isTooltipOpenHeader = false
        }
    }
}
